module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_vm._t("left")], 2), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "description"
  }, [_c('h3', {
    domProps: {
      "innerHTML": _vm._s(_vm.title)
    }
  }), _c('br'), _c('markdown', {
    attrs: {
      "source": _vm.source
    }
  }), _c('div', {
    staticClass: "row actions"
  }, [_c('div', {
    staticClass: "col-6"
  }, [_c('b-button', {
    staticClass: "btn-block",
    attrs: {
      "variant": "cancel"
    },
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v(_vm._s(_vm.$t('pos.format.modal.cancel')))])], 1), _c('div', {
    staticClass: "col-6"
  }, [_c('b-button', {
    staticClass: "btn-block",
    attrs: {
      "variant": "success",
      "data-confirm-format": _vm.type ? _vm.type : null
    },
    on: {
      "click": _vm.confirm
    }
  }, [_vm._v(_vm._s(_vm.$t('pos.format.modal.confirm')))])], 1)])], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3eefdd0c"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/campaign-format/CampaignFormatPopup.vue
// module id = 925
// module chunks = 1